import { mapGetters } from 'vuex'
import * as getters from '../../../../store/modules/getters'

export default {
  name: 'SectionControls',
  props: {
    vnodeId: {
      type: String,
      required: true,
      default: ''
    },
  },
  data() {
    return {}
  },
  computed: {
    ...mapGetters({
      viewMode: getters.VIEW_MODE,
      isGridBuilder: getters.SITE_HAS_GRIDBUILDER,
      isStandalonePopupActive: getters.STANDALONE_POPUP_ACTIVE
    }),
    isDesktopView() {
      return this.viewMode === 'desktop'
    },
    isMobileView() {
      return this.viewMode === 'phone'
    },
  },
  methods: {
    moveSectionUp(event) {
      this.$emit('moveSectionUp', event)
    },
    moveSectionDown(event) {
      this.$emit('moveSectionDown', event)
    },
    copySection(event) {
      this.$emit('copySection', event)
    },
    swapSection(event) {
      this.$emit('swapSection', event)
    },
    deleteSection(event) {
      this.$emit('deleteSection', event)
    },
  },
}
